import { Component, ViewChild } from '@angular/core';

@Component({
  selector: 'rolePage',
  templateUrl: './rolePage.component.html',
  styleUrls: ['./rolePage.component.css']
})
export class RolePageComponent {

}
